import httpManager from "@/app/shared/utils/httpManager";

export async function updateLoggedBusiness(business) {
  const url = "/settings/customer/";
  const response = await httpManager.put(url, business);
  return response?.data?.enable_bases;
}
